import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../../../components';
import { addOrRemoveSelectedNFT, AppState, changeNFTAmount } from '../../../ducks/app/actions';
import { selectAppState, selectSelectedNFTs } from '../../../ducks/app/selectors';
import { useUserNFTs } from '../../../hooks/apollo/useUserNFTs';
import { PageHeader } from '../../../components/SwapKiwi/PageHeader';
import { ReactComponent as MsKiwiEthHeart } from '../../../assets/svg/icons/ms-kiwi-eth-heart.svg';
import { SearchBar } from '../../../components/SearchBar';
import { useFilteredNFTs } from '../../../hooks/apollo/useFilteredNFTs';
import { INFT } from '../../../types/nft';
import { SKCard } from '../../../components/SwapKiwi/Card';
import { Routes } from '../../../constants/routes';
import { useHistory } from 'react-router-dom';
import { NoDataContainer } from '../../../components/SwapKiwi/NoDataContainer';

export const YourNFTs: React.FC = () => {
  const appState = useSelector(selectAppState);
  const selectedNFTs = useSelector(selectSelectedNFTs);
  const dispatch = useDispatch();
  const history = useHistory();

  const { loading, data, customAPIloading } = useUserNFTs();
  const { setSearchText, filteredList } = useFilteredNFTs(data);

  if (!loading && (!data || data?.length === 0)) {
    return (
      <NoDataContainer
        color="onion"
        message1="No NFTs found."
        message2="Sorry, we could not find any NFTs in your wallet"
        description=""
        hasCta={false}
      />
    );
  }

  if (loading) {
    return <Loader />;
  }

  const getSKCard = (NFT: INFT, isLast: boolean): JSX.Element => {
    const onNFTSelect = (): void => {
      dispatch(addOrRemoveSelectedNFT(NFT));
      if (selectedNFTs.findIndex((selectedNFT) => selectedNFT.id === NFT.id) === -1 && parseInt(NFT.amount) > 1)
        dispatch(changeNFTAmount({ id: NFT.id, amount: '1' }));
    };

    return (
      <SKCard
        size="lg"
        onSelect={onNFTSelect}
        selectable={
          appState === AppState.CREATING_SWAP ||
          (appState === AppState.ANSWER_SWAP && history.location.pathname !== '/your-nfts')
        }
        selected={selectedNFTs.findIndex((selectedNFT) => selectedNFT.id === NFT.id) !== -1}
        key={NFT.id}
        nft={NFT}
        verified={NFT.verified}
        className={isLast ? 'mr-auto' : ''}
      />
    );
  };

  return (
    <div className="bg-onion-50">
      <PageHeader
        background="lemon"
        title="Your NFTs"
        notTopBorder={false}
        description='<p class="text-lg text-cloud-900">Search for specific NFTs or just enjoy scrolling through them.<br />To start a swap hit the “Create Swap” button on the upper right.</p>'
        link={{ label: 'Learn More', url: '/faq' }}
        sticker={MsKiwiEthHeart}
        stickerWidth={272}
        breadcrumbs={{
          links: [
            {
              label: 'Home',
              slug: Routes.LANDING_ROUTE,
            },
            {
              label: 'Your NFTs',
              slug: Routes.YOUR_NFTS,
            },
          ],
        }}
      />
      <div className="app-container mx-auto pb-4">
        <SearchBar onChange={setSearchText} className="border border-cloud-600 my-4 rounded-xl" />
        <div className="flex flex-wrap justify-evenly gap-1.5">
          {filteredList.map((NFT, index) => getSKCard(NFT, index === filteredList.length - 1))}
          {customAPIloading && (
            <div className="NFT-tile center">
              <Loader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
